/**
 * UI state management slice
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  theme: 'light' | 'dark';
  language: 'en' | 'ru';
  sidebarOpen: boolean;
  selectedCategory: string | null;
  loading: {
    categories: boolean;
    playbook: boolean;
    specs: boolean;
    properties: boolean;
    property: boolean;
  };
  error: {
    message: string | null;
    details?: any;
  } | null;
}

const initialState: UiState = {
  theme: 'light',
  language: 'ru',
  sidebarOpen: false,
  selectedCategory: null,
  loading: {
    categories: false,
    playbook: false,
    specs: false,
    properties: false,
    property: false,
  },
  error: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    setSelectedCategory: (state, action: PayloadAction<string | null>) => {
      state.selectedCategory = action.payload;
    },
    setLoading: (
      state,
      action: PayloadAction<{ key: keyof UiState['loading']; value: boolean }>
    ) => {
      state.loading[action.payload.key] = action.payload.value;
    },
    setError: (state, action: PayloadAction<UiState['error']>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setLanguage: (state, action: PayloadAction<'en' | 'ru'>) => {
      state.language = action.payload;
    },
  },
});

export const {
  toggleTheme,
  setTheme,
  toggleSidebar,
  setSidebarOpen,
  setSelectedCategory,
  setLoading,
  setError,
  clearError,
  setLanguage,
} = uiSlice.actions;

export default uiSlice.reducer;